<template>
    <div :class="['file-item-container', {'center': !isShowSize}]">
        <img class="file-icon" :src="fileType(data.materialType)" alt="">
        <div :class="['file-content', {'width-78': !isDownload}]">
            <p class="overflow-ellipsis" :title="data.materialName">{{data.materialName}}</p>
            <p class="file-size" v-if="isShowSize">{{data.materialSizeFormat}}</p>
        </div>
        <div class="file-btns">
            <el-button :class="['srt-el-button', 'srt-el-button--link', 'srt-el-button-h36',{'mr-15': isDownload }] " @click="preview(data)">预览</el-button>
            <fileDownload :material="data" :tooltipDisabled="true" v-if="isDownload"></fileDownload>
        </div>
    </div>
</template>

<script setup>
import fileDownload from '@/components/file-download.vue';
import { fileType } from '@/views/resource-issue/resource-issue.js';

const emit = defineEmits(['preview']);

const props = defineProps({
    data: {
        type: Object,
        default: () => {}
    },
    isDownload: { // 是否允许下载 默认允许
        type: Boolean,
        default: true
    },
    isShowSize: { // 是否显示文件大小 默认显示
        type: Boolean,
        default: true
    }
});


function preview (data) {
    emit('preview', data);
}

</script>

<style lang="scss" scoped>
.file-item-container {
    width: 100%;
    height: 66px;
    background: #f7f9fA;
    border-radius: 4px;
    margin-top: 14px;
    padding: 10px 20px 14px 14px;
    display: flex;
    box-sizing: border-box;
    align-items: flex-start;
    font-size: 14px;
    &.center {
        align-items: center;
    }
    .file-icon {
        width: 22px;
        height: 22px;
        margin-right: 6px;
    }
    .file-content {
        width: calc(100% - 78px);
        overflow: hidden;
        &.width-78{
            width: calc(100% - 78px);
        }
        .file-size {
            color: var(--srt-color-gray);
        }
        p {
            line-height: 22px;
        }
    }
    .file-btns {
        display: flex;
        // justify-content: flex-end;
        // align-items: center;
        padding-top: 4px;
        margin-left: 22px;
        .mr-15 {
            margin-right: 15px;
        }
    }
}
</style>